import React from 'react'
import Navbar from './Navbar'
import'./Contact.css';
import './HomePage.css'
import mailIcon from'./images/mail-icon.png';
import map from './images/map.png';
import Footer from './Footer';

const Contact = () => {
  return (
    <>
   <div className='contact'>
   <div className='navbar-custom'> <Navbar/></div>

    <div className='contact-text'>
      <div className='container'>
      <div className='main'>
      <h1 style={{fontFamily:"serif"}}>Feel Free to Contact Us</h1>
      <img src={mailIcon} alt=""/>
      </div>

      <div className='row'>

        <div className='col-md-6'>

          <form>
            <input className='input' required type='text' name='name' placeholder='Name'/>
            <input className='input' required type='number' name='number'  placeholder='Phone Number'/>
            <input className='input' required type='email' name='email'  placeholder='Email'/>
            <textarea name='text-area' required placeholder='Type your massege'></textarea>
            <input type='submit' name='submit' value='send'/>
          </form>

        </div>

        <div className='col-md-6 map' >
         <img src={map} alt='map pic'/>
          

        </div>
      </div>
      </div>
    </div>
    <Footer/>
   </div>

    </>
  )
}

export default Contact;